<template>
  <div class="module-sub-qa">
    <div class="module-sub-qa-q">
      <div class="module-sub-qa-q-left">
        <img class="avatar" :src="question.src" @error="onSenderImgError"/>
      </div>
      <div class="module-sub-qa-q-middle">
        <pre class="module-sub-qa-q-middle-desc">{{ question.message }}</pre>
        <!-- <ReadMoreText class="module-sub-qa-q-middle-desc" :text="question.message"></ReadMoreText> -->
        <div class="time">{{question.sendTime}}</div>
      </div>
    </div>
    <div :class="['answers', {last: isLast}]">
      <div
        v-for="(answer, index) in answers"
        class="module-sub-qa-a"
        :key="index"
      >
        <div class="module-sub-qa-a-left">
          <img class="avatar" :src="answer.src"/>
        </div>
        <div class="module-sub-qa-a-middle">
          <div class="content">
            <span class="name">
              {{answer.name}}
              <span class="title">{{answer.title}}</span>
            </span>
            <pre v-if="!answer.audio" class="desc">{{ answer.message }}</pre>
            <voice
              v-if="answer.audio"
              class="audio"
              :isPause="(index !== pause)"
              :src="answer.audio.path"
              @start="() => pause = index"
            ></voice>
          </div>
          <!-- <ReadMoreText class="module-sub-qa-a-middle-desc" :text="answer.message"></ReadMoreText> -->
          <div class="time">{{question.sendTime}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from 'vue-avatar'
import { ReadMoreText, Voice } from '@/components'

const defaultData = {
  name: '',
  title: '',
  src: '',
  message: '',
  sendTime: ''
}

export default {
  components: {
    Avatar,
    ReadMoreText,
    'voice': Voice
  },
  props: {
    question: {
      type: Object,
      default () { return defaultData }
    },
    answers: {
      type: Array,
      default () { return [] }
    },
    isLast: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pause: -1
    }
  },
  methods: {
    onSenderImgError (event) {
      const img = event.target
      // img.src = `http://az.img.nutsbp.com/007/image/nuts_bp_logo/nuts_bp_logo_144x144.png`
      img.src = `https://az.cdn.nutsbp.com/007/image/nuts_dartcome/pc/pr/cut_page/pr_default_image_small.png`
      return img
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "var.css";
/* web */
@media screen and (min-width: 500px) {
  .module-sub-qa {
    margin-left: 53px;
    padding-top: 35px;

    & .module-sub-qa-q {
      display: flex;
      position: relative;

      & .module-sub-qa-q-left {

        & .avatar {
          width: 60px;
          border-radius: 50%;
          overflow: hidden;
        }
      }

      & .module-sub-qa-q-middle {
        flex: 1;
        display: flex;
        vertical-align: top;
        margin: 0 44px 0 29px;
        min-height: 60px;
        line-height: 1.5;

        & .module-sub-qa-q-middle-desc {
          flex: 1;
          font-size: 16px;
          white-space: pre-wrap;
          word-break: break-all;
        }

        & .time {
          flex: none;
          padding: 0 0 0 80px;
          color: var(--color6);
          font-size: 14px;
        }
      }
    }

    & .answers {
      margin-left: 88px;
      border-bottom: 1px solid var(--colorGray4);

      & .module-sub-qa-a {
        display: flex;
        position: relative;
        padding-top: 20px;
        padding-bottom: 34px;

        & .module-sub-qa-a-left {
          display: inline-block;

          & .avatar {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            overflow: hidden;
          }
        }

        & .module-sub-qa-a-middle {
          flex: 1;
          display: flex;
          vertical-align: top;
          margin: 0 44px 0 29px;
          min-height: 60px;
          line-height: 1.5;

          & .content {
            flex: 1;

            & .name {
              color: var(--color4);
              font-size: 16px;
              font-weight: bold;

              & .title {
                color: var(--colorGray1);
                font-size: 14px;
              }
            }

            & .desc {
              padding-top: 15px;
              color: var(--colorGray0);
              font-size: 14px;
              white-space: pre-wrap;
              word-break: break-all;
            }

            & .audio {
              margin: 15px 0 0 0;
              padding: 12px;
            }
          }

          & .time {
            flex: none;
            padding: 0 0 0 90px;
            color: var(--color6);
            font-size: 14px;
          }
        }
      }

      &.last {
        border-bottom: none;
      }
    }
  }
}
/* Mobile */
@media screen and (max-width: 500px) {
  .module-sub-qa {
    margin: 0 0 4.3% 4%;

    & .module-sub-qa-q {
      position: relative;
      padding: 0 4% 0 0;

      & .module-sub-qa-q-left {
        display: inline-block;
        width: 11%;

        & .avatar {
          width: 100%;
          border-radius: 50%;
          overflow: hidden;
        }
      }

      & .module-sub-qa-q-middle {
        position: relative;
        display: inline-block;
        vertical-align: top;
        padding: 0 0 0 2.5%;
        width: 84%;

        & .module-sub-qa-q-middle-desc {
          font-size: 13px;
          line-height: 1.25;
          white-space: pre-wrap;
          word-break: break-all;
        }

        & .time {
          position: relative;
          padding: 10px 0 0 0;
          color: var(--colorDisabled);
          font-size: 12px;
        }
      }
    }

    & .answers {
      margin: 0 0 0 6.5%;

      & .module-sub-qa-a {
        position: relative;
        display: flex;
        padding: 4.6% 0 0 0;

        &:last-child {
          & .module-sub-qa-a-middle {
            padding: 0 4% 15px 0;
            border-bottom: 1px solid var(--colorGray4);
          }
        }

        & .module-sub-qa-a-left {
          flex: none;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          overflow: hidden;

          & .avatar {
            width: 100%;
          }
        }

        & .module-sub-qa-a-middle {
          flex: 1;
          position: relative;
          vertical-align: top;
          margin: 0 0 0 2.5%;
          padding: 0 4% 0 0;

          & .content {
            & .name {
              color: var(--color4);
              font-size: 14px;
              font-weight: bold;

              & .title {
                color: var(--colorGray1);
                font-size: 10px;
              }
            }

            & .desc {
              padding: 2% 5% 0 0;
              color: var(--colorGray0);
              font-size: 13px;
              line-height: 1.25;
              white-space: pre-wrap;
              word-break: break-all;
            }

            & .audio {
              margin: 2% 5% 0 0;
              padding: 12px;
            }

          }

          & .time {
            position: relative;
            padding: 5px 0 0 0;
            color: var(--colorDisabled);
            font-size: 12px;
          }
        }
      }

      &.last {
        & .module-sub-qa-a {
          &:last-child {
            & .module-sub-qa-a-middle {
              padding: 0 4% 0 0;
              border-bottom: 1px solid rgba(0,0,0,0);
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/module/sub/Qa.vue